import { ComponentType, useState } from 'react'
import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    ImageInput,
    required,
    useRecordContext,
} from 'react-admin'
import { Grid } from '@material-ui/core'

const EditMarketplaceItem: ComponentType = () => {
    // TODO: fix that, what is it?
    const [, setNewImage] = useState(false)

    const ImageDisplay = (props: any) => {
        const record = useRecordContext(props)
        return (
            <img
                alt={record.itemName}
                style={{ maxHeight: 400 }}
                src={record.undefined}
            />
        )
    }

    return (
        <Create title="Create new Marketplace Item" redirect="list">
            <SimpleForm>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Grid container>
                        <Grid item xs={3}>
                            <TextInput
                                source="itemName"
                                validate={required()}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput
                                source="category"
                                validate={required()}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <NumberInput source="cost" validate={required()} />
                        </Grid>
                        <Grid item xs={3}>
                            <NumberInput source="quantity" />
                        </Grid>
                        <Grid item xs={12}>
                            <TextInput
                                source="itemDescription"
                                fullWidth
                                multiline
                                validate={required()}
                            />
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            marginLeft: 20,
                        }}
                    >
                        <ImageInput
                            accept="image/*"
                            onChange={(e) => {
                                setNewImage(!!e)
                            }}
                            source="newImage"
                            labelSingle="Drop a picture to upload, or click to select it. Best displayed in 280x160 ratio."
                        >
                            <ImageDisplay />
                        </ImageInput>
                    </div>
                </div>
            </SimpleForm>
        </Create>
    )
}

export default EditMarketplaceItem
